<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-10-26 11:01:21
 * @LastEditors: yd
 * @LastEditTime: 2020-10-26 14:10:03
-->
<template>
  <v-skeleton-loader :type='type'
                     v-bind="$attrs"
                     v-on="$listeners">
    <slot></slot>
  </v-skeleton-loader>
</template>
 
<script>
export default {
  components: {

  },
  props: {
    type: {
      type: String,
      default: 'table-heading, list-item-two-line, image, table-tfoot'
    }
  },
  data () {
    return {

    };
  },
  computed: {},
  created () { },
  watch: {},
  mounted () { },
  methods: {

  },
};
</script>

<style scoped>
</style>
